export const environment = {
    production: false,
    apiUrl: 'https://amatramspacentre.backend.dev.helpinghandsforstudents.com',
    clientId:'qwerty-karkardooma-spa'
  };